export const CoachChallengeReason = {
  name: "coach-challenge-reason",
  component: "MainPanel",
  layout: "main-panel large",
  mode: "visible",
  text: "coach-challenge.reason",
  showOn: [
    {
      state: "primary",
      value: "coach-challenge-reason",
      operator: "is",
    }],
  allowCancel: true,
  children: [
    {
      name: "coach-challenge-reason-types",
      component: "ButtonGroup",
      layout: "button-group",
      mode: "visible",
      showOn: [true],
      options: {
        value: "singleOption",
        optionName: "reason",
        layout: "type-button",
        prefix: "reason",
        children: [
          "period_end",
          "clock_correction",
          "shot_clock_violation",
          "non_shooting_foul",
          "goaltending",
          "out_of_bounds",
          "field_goal_success",
          "free_throws_shooting_foul",
          "foul_change",
          "identify_ft_shooter",
          "violence",
        ],
      },
      actionGroups: [
        {
          actions: [
            { action: "sendEvent", value: "edit", type: "main" },
            {
              action: "nextState",
              value: "coach-challenge-decision",
              type: "primary",
            },
          ],
          conditions: [],
        },
      ],
    },
  ],
};
